import { render, staticRenderFns } from "./DepotManage.vue?vue&type=template&id=5c837264&scoped=true&"
import script from "./DepotManage.vue?vue&type=script&lang=js&"
export * from "./DepotManage.vue?vue&type=script&lang=js&"
import style0 from "./DepotManage.vue?vue&type=style&index=0&id=5c837264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c837264",
  null
  
)

export default component.exports